(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.bundle-builder[data-section-id]');
    let openSection = null;
    let openPanelType = null;
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const setPageScrollLock = (locked) => {
      document.documentElement.style.overflow = locked
        ? 'hidden'
        : '';
      document.body.style.overflow = locked
        ? 'hidden'
        : '';
    };

    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      

      section.dataset.initialized = 'true';

      const panel = section.querySelector('[data-box-panel]');
      const moreInfoPanel = section.querySelector('[data-more-info-panel]');
      const overlay = section.querySelector('[data-box-overlay]');
      const footer = section.querySelector('.bundle-builder__footer');
      const toggles = section.querySelectorAll('[data-box-toggle]');
      const closeButton = section.querySelector('[data-box-close]');
      const panelContent = section.querySelector('.bundle-builder-panel__content');
      const moreInfoCloseButton = section.querySelector('[data-more-info-close]');
      const moreInfoPanelContent = section.querySelector('[data-more-info-content]');
      const moreInfoLoading = section.querySelector('[data-more-info-loading]');
      const moreInfoError = section.querySelector('[data-more-info-error]');
      const moreInfoBody = section.querySelector('[data-more-info-body]');
      const moreInfoControlRegion = section.querySelector('[data-more-info-control-region]');
      let lastActiveElement = null;
      let activeMoreInfoProductId = null;
      let activeMoreInfoRequestId = 0;
      const moreInfoCache = new Map();

      if (overlay && ! overlay.dataset.portalized) {
        document.body.appendChild(overlay);
        overlay.dataset.portalized = 'true';
      }

      if (footer && ! footer.dataset.portalized) {
        document.body.appendChild(footer);
        footer.dataset.portalized = 'true';
      }

      if (panel && ! panel.dataset.portalized) {
        document.body.appendChild(panel);
        panel.dataset.portalized = 'true';
      }

      if (moreInfoPanel && ! moreInfoPanel.dataset.portalized) {
        document.body.appendChild(moreInfoPanel);
        moreInfoPanel.dataset.portalized = 'true';
      }

      const footerSpacer = section.querySelector('.bundle-builder__footer-spacer');
      const syncFooterSpace = () => {
        if (!footer || !footerSpacer) return;
        footerSpacer.style.height = `${Math.ceil(footer.getBoundingClientRect().height) + 24}px`;
      };
      const footerObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(syncFooterSpace) : null;
      if (footer) footerObserver?.observe(footer);
      syncFooterSpace();
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(section)) return;
        footerObserver?.disconnect();
        [footer, panel, moreInfoPanel, overlay].forEach((node) => node?.remove());
      });

      const setExclusivePressedState = (elements, activeElement) => {
        elements.forEach((element) => {
          const isActive = element === activeElement;
          element.classList.toggle('is-active', isActive);
          element.setAttribute('aria-pressed', String(isActive));
        });
      };

      const getPanelByType = (type) => {
        if (type === 'box') return panel;
        

        if (type === 'info') return moreInfoPanel;
        

        return null;
      };

      const updateBoxToggleState = (expanded) => {
        toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(expanded)));
      };

      const closePanelForSection = (targetSection, type, restoreFocus = true) => {
        const isCurrentSection = targetSection === section;
        const targetPanel = isCurrentSection
          ? (
            type === 'box'
              ? panel
              : moreInfoPanel
          )
          : (
            type === 'box'
              ? targetSection.querySelector('[data-box-panel]')
              : targetSection.querySelector('[data-more-info-panel]')
          );
        const targetOverlay = isCurrentSection
          ? overlay
          : targetSection.querySelector('[data-box-overlay]');
        const targetToggles = isCurrentSection
          ? toggles
          : targetSection.querySelectorAll('[data-box-toggle]');

        if (type === 'box') {
          targetSection.classList.remove('is-panel-open');
          targetToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
        }

        if (targetPanel) {
          targetPanel.setAttribute('aria-hidden', 'true');
          targetPanel.style.transform = 'translateX(100%)';
          targetPanel.style.visibility = 'hidden';
          targetPanel.style.pointerEvents = 'none';
        }

        if (targetOverlay) 
          targetOverlay.hidden = true;
        


        if (openSection === targetSection && openPanelType === type) {
          openSection = null;
          openPanelType = null;
          setPageScrollLock(false);
        }

        if (restoreFocus && lastActiveElement && typeof lastActiveElement.focus === 'function') {
          lastActiveElement.focus();
        }
      };

      const openBoxPanel = (triggerElement) => {
        openPanelByType('box', triggerElement);
      };

      const closeBoxPanel = (restoreFocus = true) => {
        closePanelForSection(section, 'box', restoreFocus);
      };

      const openMoreInfoPanel = (triggerElement) => {
        openPanelByType('info', triggerElement);
      };

      const closeMoreInfoPanel = (restoreFocus = true) => {
        closePanelForSection(section, 'info', restoreFocus);
      };

      const openPanelByType = (type, triggerElement) => {
        const targetPanel = getPanelByType(type);
        if (! targetPanel) return;
        


        lastActiveElement = triggerElement || document.activeElement;

        if (openSection) {
          closePanelForSection(openSection, openPanelType, false);
        }

        if (type === 'box') {
          section.classList.add('is-panel-open');
          updateBoxToggleState(true);
          if (panelContent) 
            panelContent.scrollTop = 0;
          

          panel.scrollTop = 0;
        } else if (moreInfoPanelContent) {
          moreInfoPanelContent.scrollTop = 0;
          moreInfoPanel.scrollTop = 0;
        }

        targetPanel.setAttribute('aria-hidden', 'false');
        targetPanel.style.transform = 'translateX(0)';
        targetPanel.style.visibility = 'visible';
        targetPanel.style.pointerEvents = 'auto';
        overlay.hidden = false;
        setPageScrollLock(true);
        openSection = section;
        openPanelType = type;

        const focusableElements = targetPanel.querySelectorAll(focusableSelector);
        if (focusableElements.length > 0) {
          focusableElements[0].focus();
        }
      };

      const countNodeRoots = [section, footer, panel].filter(Boolean);
      const selectedCountNodes = countNodeRoots.flatMap((root) => [...root.querySelectorAll('[data-selected-count]')]);
      const minimumCountNodes = countNodeRoots.flatMap((root) => [...root.querySelectorAll('[data-minimum-count]')]);
      const maximumCountNodes = countNodeRoots.flatMap((root) => [...root.querySelectorAll('[data-maximum-count]')]);
      const remainingCountNodes = countNodeRoots.flatMap((root) => [...root.querySelectorAll('[data-remaining-count]')]);
      const progressMessageNodes = countNodeRoots.flatMap((root) => [...root.querySelectorAll('[data-progress-message]')]);
      const progressBars = countNodeRoots.flatMap((root) => [...root.querySelectorAll('[data-progress-bar]')]);
      const progressMarkers = countNodeRoots.flatMap((root) => [...root.querySelectorAll('[data-progress-marker]')]);
      const bundleCtas = countNodeRoots.flatMap((root) => [...root.querySelectorAll('.bundle-builder__footer-cta, .bundle-builder-panel__cta')]);
      const submitBundleButtons = countNodeRoots.flatMap((root) => [...root.querySelectorAll('[data-submit-bundle]')]);
      const currentTotalNodes = footer
        ? [... footer.querySelectorAll('[data-current-total]')]
        : [];
      const currentTotalCompareNodes = footer
        ? [... footer.querySelectorAll('[data-current-total-compare]')]
        : [];
      const currentTotalDiscountNodes = footer
        ? [... footer.querySelectorAll('[data-current-total-discount]')]
        : [];
      const currentTotalNoteNodes = footer
        ? [... footer.querySelectorAll('[data-current-total-note]')]
        : [];

      const frequencySelect = footer ?. querySelector('[data-frequency-select]');
      const boxEmptyState = panel ?. querySelector('[data-box-empty]');
      const boxItems = panel ?. querySelector('[data-box-items]');
      const productCards = [...section.querySelectorAll('[data-product-card]')];
      const moreInfoButtons = section.querySelectorAll('[data-more-info]');
      const statusMessage = footer?.querySelector('[data-status-message]');
      const bundleSize1Threshold = Number.parseInt(section.dataset.minimumMeals || '12', 10) || 12;
      const configuredBundleSize2Threshold = Number.parseInt(section.dataset.shippingThreshold || '24', 10) || 24;
      const bundleSize2Threshold = Math.max(configuredBundleSize2Threshold, bundleSize1Threshold);
      const configuredBundleSize3Threshold = Number.parseInt(section.dataset.discountThreshold || '30', 10) || 30;
      const bundleSize3Threshold = Math.max(configuredBundleSize3Threshold, bundleSize2Threshold);
      const bundleSize1Message = section.dataset.minimumMessage || 'Add at least 12 to continue';
      const bundleSize2Message = section.dataset.shippingMessage || 'Add [remaining] more for free shipping';
      const bundleSize2ReachedMessage = section.dataset.shippingReachedMessage || '🎉 Free shipping unlocked, add [remaining] more to save $20+';
      const bundleSize3ReachedMessage = section.dataset.discountReachedMessage || '🎁 You unlocked $20+ savings + free shipping';
      const bundleSize2Note = section.dataset.shippingNote || 'Free shipping';
      const minimumBundleSize = bundleSize1Threshold;
      const maximumBundleSize = Math.max(bundleSize3Threshold, Number.parseInt(section.dataset.maximumBundleSize, 10) || 36);
      const discountBasisPoints = Math.min(10000, Math.max(0, Number.parseInt(section.dataset.discountBasisPoints, 10) || 0));
      const shippingCents = Math.max(0, Number.parseInt(section.dataset.shippingCents, 10) || 0);
      const priceMessages = JSON.parse(section.querySelector('[data-price-messages]').textContent);
      let requiresFrequencySelection = false;
      const quantities = new Map();
      const productData = new Map();
      const addOrder = [];
      const editBundleId = new URLSearchParams(window.location.search).get('edit_bundle');
      let statusMessageTimer = null;
      let isSubmittingBundle = false;
      let activeBundleId = null;

      productCards.forEach((card) => {
        const productId = card.dataset.productId;
        if (! productId) return;
        


        productData.set(productId, {
          title: card.dataset.productTitle || '',
          menuTitle: card.dataset.menuTitle || '',
          image: card.dataset.productImage || '',
          handle: card.dataset.productHandle || '',
          url: card.dataset.productUrl || '',
          variantId: card.dataset.variantId || '',
          priceCents: Number.parseInt(card.dataset.variantPrice, 10),
          sellingPlanPrices: JSON.parse(card.querySelector('[data-selling-plan-prices]')?.textContent || '[]'),
          isSoldOut: card.dataset.isSoldOut === 'true',
          sellingPlanGroups: []
        });

        const sellingPlanGroupsNode = card.querySelector('[data-selling-plan-groups]');
        if (sellingPlanGroupsNode) {
          try {
            productData.get(productId).sellingPlanGroups = JSON.parse(sellingPlanGroupsNode.textContent || '[]');
          } catch (error) {
            productData.get(productId).sellingPlanGroups = [];
          }
        }
      });

      const announceStatus = (message, persistent = false) => {
        if (! statusMessage) return;
        


        if (statusMessageTimer) {
          window.clearTimeout(statusMessageTimer);
        }

        if (!message) {
          statusMessage.hidden = true;
          statusMessage.textContent = '';
          return;
        }

        statusMessage.textContent = message;
        statusMessage.hidden = false;
        if (persistent) return;
        statusMessageTimer = window.setTimeout(() => {
          statusMessage.hidden = true;
          statusMessage.textContent = '';
        }, 3200);
      };

      const escapeHtml = (value) => String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

      const formatCurrency = (cents) => {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: section.dataset.currency || 'USD'
        }).format(Math.max(cents, 0) / 100);
      };

      const getSelectedCount = () => {
        let count = 0;
        quantities.forEach((quantity) => {
          count += quantity;
        });
        return count;
      };

      const getBundleSummary = () => {
        const lines = [];
        const seenProductIds = new Set();

        addOrder.forEach((productId) => {
          if (seenProductIds.has(productId)) return;
          

          seenProductIds.add(productId);

          const quantity = quantities.get(productId) || 0;
          if (quantity <= 0) return;
          


          const details = productData.get(productId) || {};
          lines.push(`${
            details.title || 'Untitled product'
          } x ${quantity}`);
        });

        return lines;
      };

      const getFrequencySelection = () => {
        const selectedOption = frequencySelect?.selectedOptions?.[0];
        if (! selectedOption) {
          return {
            count: 2,
            unit: 'WEEK',
            label: ''
          };
        }

        return {
          count: selectedOption.dataset.frequencyCount || '2',
          unit: selectedOption.dataset.frequencyUnit || 'WEEK',
          label: selectedOption.textContent?.trim() || ''
        };
      };

      const getBundlePropertyValue = (selectedCount) => {
        if (selectedCount >= bundleSize3Threshold) {
          return 'large-bundle';
        }

        if (selectedCount >= bundleSize2Threshold) {
          return 'big-bundle';
        }

        return 'small-bundle';
      };

      const createBundleId = () => {
        if (window.crypto?.randomUUID) {
          return window.crypto.randomUUID();
        }

        return `bundle-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      };

      const getSellingPlanIdForProduct = (productId) => {
        const details = productData.get(productId);
        if (! details) return null;

        const frequency = getFrequencySelection();
        const candidateGroups = details.sellingPlanGroups || [];

        for (const group of candidateGroups) {
          for (const sellingPlan of group.selling_plans || []) {
            for (const option of sellingPlan.options || []) {
              if (option.name !== 'SUBSCRIBE') continue;

              const normalizedValue = String(option.value || '').trim().toUpperCase();
              const [unit, count, billingUnit, billingCount] = normalizedValue.split(/\s+/);
              const isPayPerDelivery = !billingUnit || (billingUnit === unit && billingCount === count);

              if (isPayPerDelivery && count === String(frequency.count) && unit === String(frequency.unit)) {
                return sellingPlan.id;
              }
            }
          }
        }

        return null;
      };

      const getCartPayload = () => {
        const selectedCount = getSelectedCount();
        const bundlePropertyValue = getBundlePropertyValue(selectedCount);
        const bundleFrequencyValue = frequencySelect?.value || '';
        const bundleFrequencyLabel = getFrequencySelection().label || '';
        const bundleId = activeBundleId || createBundleId();
        const items = [];

        quantities.forEach((quantity, productId) => {
          if (quantity <= 0) return;

          const details = productData.get(productId);
          const variantId = Number.parseInt(details?.variantId || '', 10);
          if (! variantId) return;

          const item = {
            id: variantId,
            quantity,
            properties: {
              _bundle: bundlePropertyValue,
              _bundle_id: bundleId,
              _bundle_frequency: bundleFrequencyValue,
              _bundle_frequency_label: bundleFrequencyLabel
            }
          };

          const sellingPlanId = getSellingPlanIdForProduct(productId);
          if (sellingPlanId) {
            item.selling_plan = sellingPlanId;
          }

          items.push(item);
        });

        return {
          items,
          bundleId,
          bundlePropertyValue
        };
      };

      const setSubmittingState = (submitting) => {
        isSubmittingBundle = submitting;

        submitBundleButtons.forEach((button) => {
          button.disabled = submitting || button.disabled;
          const labelNode = button.querySelector('[data-cta-label]');
          if (! labelNode) return;

          if (submitting) {
            labelNode.textContent = priceMessages.addingToCart;
          }
        });

        if (! submitting) {
          updateBundleState();
        }
      };

      const openCartDrawer = (usedAjaxCart) => {
        if (usedAjaxCart) {
          document.body.classList.add('js-ajax-cart-open');
          return;
        }

        window.location.href = `${window.Shopify.routes.root}cart`;
      };

      const requestLiquidAjaxCart = (requestType, body) => new Promise((resolve, reject) => {
        if (! ('liquidAjaxCart' in window)) {
          reject(new Error('Liquid Ajax Cart is not available'));
          return;
        }

        const requestFn = requestType === 'clear'
          ? window.liquidAjaxCart.cartRequestClear
          : window.liquidAjaxCart.cartRequestAdd;

        requestFn(body, {
          lastComplete: (requestState) => {
            if (requestState?.responseData?.ok) {
              resolve(requestState);
              return;
            }

            const description = requestState?.responseData?.body?.description
              || requestState?.responseData?.body?.message
              || `Failed to ${requestType} cart`;
            reject(new Error(description));
          }
        });
      });

      const resetBundleBuilder = () => {
        quantities.forEach((value, productId) => {
          quantities.set(productId, 0);
        });
        addOrder.length = 0;
        activeBundleId = null;
        updateBundleState();
      };

      const syncFrequencySelection = (bundleFrequencyValue) => {
        if (! frequencySelect || ! bundleFrequencyValue) return false;

        const hasMatchingOption = [...frequencySelect.options].some((option) => option.value === bundleFrequencyValue);
        if (! hasMatchingOption) return false;

        frequencySelect.value = bundleFrequencyValue;
        return true;
      };

      const hydrateBundleFromCart = async () => {
        if (! editBundleId) return;

        try {
          console.info('[Bundle Builder] Edit requested', {
            editBundleId
          });

          const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (! response.ok) {
            throw new Error('Failed to load cart');
          }

          const cart = await response.json();
          const allBundleItems = (cart.items || []).filter((item) => item?.properties?._bundle);
          let bundleItems = allBundleItems.filter((item) => item?.properties?._bundle_id === editBundleId);

          if (bundleItems.length === 0 && editBundleId === 'legacy-bundle') {
            bundleItems = allBundleItems.filter((item) => ! item?.properties?._bundle_id);
          }

          console.info('[Bundle Builder] Cart bundle candidates', allBundleItems.map((item) => ({
            title: item.product_title,
            quantity: item.quantity,
            bundle: item.properties?._bundle || '',
            bundleId: item.properties?._bundle_id || '',
            bundleFrequency: item.properties?._bundle_frequency || ''
          })));

          console.info('[Bundle Builder] Matched bundle items', {
            editBundleId,
            matchedCount: bundleItems.length
          });

          if (bundleItems.length === 0) {
            console.warn('[Bundle Builder] No matching bundle items found for edit request', {
              editBundleId
            });
            announceStatus('That bundle is no longer in your cart.');
            return;
          }

          quantities.forEach((value, productId) => {
            quantities.set(productId, 0);
          });
          addOrder.length = 0;
          activeBundleId = editBundleId;

          const storedFrequency = bundleItems[0]?.properties?._bundle_frequency;
          if (storedFrequency && !syncFrequencySelection(storedFrequency)) {
            requiresFrequencySelection = true;
            frequencySelect.value = '';
            announceStatus(priceMessages.chooseFrequency);
          }

          const productIdByVariantId = new Map();
          productData.forEach((details, productId) => {
            const variantId = Number.parseInt(details?.variantId || '', 10);
            if (variantId) {
              productIdByVariantId.set(variantId, productId);
            }
          });

          bundleItems.forEach((item) => {
            const variantId = Number.parseInt(item.variant_id || '', 10);
            const productId = productIdByVariantId.get(variantId);
            const quantity = Number.parseInt(item.quantity || '0', 10) || 0;

            if (! productId || quantity <= 0) {
              console.warn('[Bundle Builder] Skipping bundle item during hydration', {
                title: item.product_title,
                variantId,
                quantity,
                matchedProductId: productId || null
              });
              return;
            }

            quantities.set(productId, quantity);
            for (let index = 0; index < quantity; index += 1) {
              addOrder.push(productId);
            }
          });

          console.info('[Bundle Builder] Hydrated selections', {
            activeBundleId,
            selectedCount: getSelectedCount(),
            selectedFrequency: frequencySelect?.value || '',
            addOrder
          });

          updateBundleState();

          if (window.history?.replaceState) {
            const nextUrl = new URL(window.location.href);
            nextUrl.searchParams.delete('edit_bundle');
            window.history.replaceState({}, document.title, nextUrl.toString());
          }
        } catch (error) {
          console.error('[Bundle Builder] Failed to hydrate bundle from cart', error);
          announceStatus('We could not load that bundle. Please try again.');
        }
      };

      const submitBundle = async () => {
        if (isSubmittingBundle) return;
        if (requiresFrequencySelection || !frequencySelect?.value) {
          announceStatus(priceMessages.chooseFrequency);
          frequencySelect?.focus();
          return;
        }
        if (!getCurrentPriceState(getSelectedCount()).valid) {
          announceStatus(priceMessages.unavailable);
          return;
        }

        const selectedCount = getSelectedCount();
        const progressState = getProgressState(selectedCount);
        if (! progressState.canCheckout) return;

        const payload = getCartPayload();
        if (payload.items.length === 0) {
          announceStatus('Add meals to your box before continuing.');
          return;
        }

        const itemsMissingSellingPlan = payload.items.some((item) => ! item.selling_plan);
        if (itemsMissingSellingPlan) {
          announceStatus('A subscription plan could not be matched for one or more meals. Check the delivery schedule and try again.', true);
          return;
        }

        announceStatus('');
        setSubmittingState(true);

        const usedAjaxCart = typeof window.liquidAjaxCart?.cartRequestClear === 'function'
          && typeof window.liquidAjaxCart?.cartRequestAdd === 'function';
        try {
          if (usedAjaxCart) {
            await requestLiquidAjaxCart('clear', {});
            await requestLiquidAjaxCart('add', {
              items: payload.items
            });
          } else {
            const clearCartResponse = await fetch(`${window.Shopify.routes.root}cart/clear.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            });

            if (! clearCartResponse.ok) {
              throw new Error('Failed to clear cart');
            }

            const addToCartResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                items: payload.items
              })
            });

            if (! addToCartResponse.ok) {
              throw new Error('Failed to add bundle to cart');
            }

            await addToCartResponse.json();
          }

          activeBundleId = payload.bundleId;
          resetBundleBuilder();
          if (openSection === section && openPanelType === 'box') {
            closeBoxPanel(false);
          }
          openCartDrawer(usedAjaxCart);
        } catch (error) {
          announceStatus('We could not add this bundle right now. Please try again.', true);
        } finally {
          setSubmittingState(false);
        }
      };

      const calculateBundlePricing = (lines, offer) => {
        let subtotalCents = 0;
        let planSubtotalCents = 0;
        let count = 0;
        for (const line of lines) {
          if (!Number.isInteger(line.quantity) || line.quantity < 0 || !Number.isInteger(line.priceCents) || line.priceCents < 0) {
            return { valid: false };
          }
          count += line.quantity;
          subtotalCents += line.priceCents * line.quantity;
          const planPrice = Number.isInteger(line.planPriceCents) && line.planPriceCents >= 0
            ? line.planPriceCents : line.priceCents;
          planSubtotalCents += planPrice * line.quantity;
        }
        const rewardCents = count >= offer.rewardThreshold
          ? Math.round(subtotalCents * offer.discountBasisPoints / 10000) : 0;
        const totalCents = Math.min(planSubtotalCents, subtotalCents - rewardCents);
        return {
          valid: true,
          count,
          subtotalCents,
          totalCents,
          discountCents: Math.max(0, subtotalCents - totalCents),
          shippingCents: count >= offer.shippingThreshold ? 0 : offer.shippingCents,
          canCheckout: count >= offer.minimum && count <= offer.maximum
        };
      };

      const getCurrentPriceState = (selectedCount) => {
        const lines = [];
        quantities.forEach((quantity, productId) => {
          if (quantity <= 0) return;
          const details = productData.get(productId);
          const planId = getSellingPlanIdForProduct(productId);
          const allocation = details?.sellingPlanPrices.find((plan) => String(plan.id) === String(planId));
          lines.push({ quantity, priceCents: details?.priceCents, planPriceCents: allocation?.price });
        });
        const pricing = calculateBundlePricing(lines, {
          minimum: minimumBundleSize,
          maximum: maximumBundleSize,
          rewardThreshold: bundleSize3Threshold,
          shippingThreshold: bundleSize2Threshold,
          discountBasisPoints,
          shippingCents
        });
        const showPrice = pricing.valid && selectedCount >= minimumBundleSize;
        return {
          valid: pricing.valid,
          compareAt: showPrice && pricing.discountCents > 0 ? formatCurrency(pricing.subtotalCents) : '',
          discountLabel: showPrice && pricing.discountCents > 0
            ? priceMessages.savings.replace('[amount]', formatCurrency(pricing.discountCents)) : '',
          note: !pricing.valid ? priceMessages.unavailable
            : !showPrice ? bundleSize1Message
            : pricing.shippingCents === 0 ? bundleSize2Note
            : priceMessages.shipping.replace('[amount]', formatCurrency(pricing.shippingCents)),
          noteHighlighted: showPrice && pricing.shippingCents === 0,
          showPrice,
          total: showPrice ? formatCurrency(pricing.totalCents) : ''
        };
      };

      const getProgressState = (selectedCount) => {
        const progressPercent = Math.max(0, Math.min(selectedCount / maximumBundleSize * 100, 100));
        const canCheckout = selectedCount >= minimumBundleSize && selectedCount <= maximumBundleSize;
        if (selectedCount < bundleSize1Threshold) {
          return {
            remainingCount: Math.max(bundleSize1Threshold - selectedCount, 0),
            progressPercent,
            progressMessage: bundleSize1Message,
            canCheckout,
            currentThreshold: bundleSize1Threshold
          };
        }
        if (selectedCount < bundleSize2Threshold) {
          return {
            remainingCount: 0,
            progressPercent,
            progressMessage: bundleSize2Message.replace(/\[\s*remaining\s*\]/gi, String(Math.max(bundleSize2Threshold - selectedCount, 0))),
            canCheckout,
            currentThreshold: bundleSize2Threshold
          };
        }
        if (selectedCount < bundleSize3Threshold) {
          return {
            remainingCount: 0,
            progressPercent,
            progressMessage: bundleSize2ReachedMessage.replace(/\[\s*remaining\s*\]/gi, String(Math.max(bundleSize3Threshold - selectedCount, 0))),
            canCheckout,
            currentThreshold: bundleSize3Threshold
          };
        }
        return {
          remainingCount: 0,
          progressPercent,
          progressMessage: bundleSize3ReachedMessage,
          canCheckout,
          currentThreshold: bundleSize3Threshold
        };
      };

      const initMoreInfoGallery = (root) => {
        if (!root) return;
        


        const thumbs = root.querySelectorAll('[data-more-info-thumb]');
        const slides = root.querySelectorAll('[data-more-info-slide]');
        if (thumbs.length === 0 || slides.length === 0) return;
        


        thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const slideIndex = Number.parseInt(thumb.dataset.slideIndex || '0', 10);

            thumbs.forEach((button) => {
              const isActive = button === thumb;
              button.classList.toggle('is-active', isActive);
              button.setAttribute('aria-pressed', String(isActive));
            });

            slides.forEach((slide, index) => {
              const isActive = index === slideIndex;
              slide.classList.toggle('is-active', isActive);
              slide.hidden = ! isActive;
            });
          });
        });
      };

      const initMoreInfoReviews = (root) => {
        if (!root) return;
        

        const reviewNodes = root.querySelectorAll('.yotpo.bottomLine');
        if (reviewNodes.length === 0) return;
        


        if (window.yotpo ?. initWidgets) {
          window.yotpo.initWidgets();
        } else if (window.yotpo ?. refreshWidgets) {
          window.yotpo.refreshWidgets();
        }
      };

      const removeLatestSelections = (overflowCount) => {
        let remainingOverflow = overflowCount;

        while (remainingOverflow > 0 && addOrder.length > 0) {
          const productId = addOrder.pop();
          const currentQuantity = quantities.get(productId) || 0;

          if (currentQuantity > 0) {
            quantities.set(productId, currentQuantity - 1);
            remainingOverflow -= 1;
          }
        }
      };

      const incrementProduct = (productId) => {
        const details = productData.get(productId) || {};
        if (details.isSoldOut) return false;

        const currentQuantity = quantities.get(productId) || 0;
        if (getSelectedCount() >= maximumBundleSize && currentQuantity === 0) return false;
        

        if (getSelectedCount() >= maximumBundleSize) return false;
        


        quantities.set(productId, currentQuantity + 1);
        addOrder.push(productId);
        updateBundleState();
        return true;
      };

      const decrementProduct = (productId) => {
        const currentQuantity = quantities.get(productId) || 0;
        if (currentQuantity <= 0) return false;
        


        quantities.set(productId, currentQuantity - 1);
        const latestIndex = addOrder.lastIndexOf(productId);
        if (latestIndex > -1) {
          addOrder.splice(latestIndex, 1);
        }
        updateBundleState();
        return true;
      };

      const renderMoreInfoControl = () => {
        if (! moreInfoControlRegion) return;
        


        if (! activeMoreInfoProductId || ! productData.has(activeMoreInfoProductId)) {
          moreInfoControlRegion.innerHTML = '';
          return;
        }

        const details = productData.get(activeMoreInfoProductId) || {};
        const quantity = quantities.get(activeMoreInfoProductId) || 0;
        const isPackFull = getSelectedCount() >= maximumBundleSize;
        const isSoldOut = details.isSoldOut === true;
        const safeTitle = escapeHtml(details.title || 'product');

        if (quantity > 0) {
          moreInfoControlRegion.innerHTML = `
            <div class="bundle-builder-more-info-control__quantity" data-more-info-quantity-control>
              <button
                type="button"
                class="bundle-builder-more-info-control__button"
                data-more-info-decrement
                aria-label="Decrease quantity for ${safeTitle}"
              >
                &minus;
              </button>
              <span class="bundle-builder-more-info-control__value" aria-live="polite">${quantity}</span>
              <button
                type="button"
                class="bundle-builder-more-info-control__button"
                data-more-info-increment
                aria-label="Increase quantity for ${safeTitle}"
                ${
            isPackFull || isSoldOut
              ? 'disabled'
              : ''
            }
              >
                +
              </button>
            </div>
          `;
        } else {
          moreInfoControlRegion.innerHTML = `
            <button
              type="button"
              class="bundle-builder-more-info-control__action button secondary"
              data-more-info-add
              aria-label="${
            isSoldOut
              ? `${safeTitle} is sold out`
              : `Add ${safeTitle} to pack`
            }"
              ${
            isPackFull || isSoldOut
              ? 'disabled'
              : ''
            }
            >
              ${
            isSoldOut
              ? 'SOLD OUT'
              : 'ADD TO PACK'
            }
            </button>
          `;
        }
      };

      const renderBoxItems = () => {
        if (! boxItems) return;
        


        const selectedCount = getSelectedCount();
        const renderedProductIds = [];
        const seenProductIds = new Set();

        addOrder.forEach((productId) => {
          const quantity = quantities.get(productId) || 0;
          if (quantity > 0 && ! seenProductIds.has(productId)) {
            renderedProductIds.push(productId);
            seenProductIds.add(productId);
          }
        });

        const existingItems = new Map([... boxItems.querySelectorAll('[data-box-line-item]')].map((item) => [item.dataset.productId, item]));

        renderedProductIds.forEach((productId) => {
          const quantity = quantities.get(productId) || 0;
          const details = productData.get(productId) || {};
          const safeTitle = escapeHtml(details.title || '');
          const safeMenuTitle = escapeHtml(details.menuTitle || '');
          const safeImage = escapeHtml(details.image || '');
          const isPackFull = selectedCount >= maximumBundleSize;
          let item = existingItems.get(productId);

          if (! item) {
            item = document.createElement('div');
            item.className = 'bundle-builder-line-item';
            item.dataset.boxLineItem = '';
            item.dataset.productId = productId;
            item.innerHTML = `
              <div class="bundle-builder-line-item__image"></div>
              <div class="bundle-builder-line-item__details">
                <h3 class="bundle-builder-line-item__title"></h3>
                <p class="bundle-builder-line-item__category"></p>
              </div>
              <div class="bundle-builder-line-item__controls">
                <button
                  type="button"
                  class="bundle-builder-line-item__control bundle-builder-line-item__control--ghost"
                  data-box-decrement
                >
                  &minus;
                </button>
                <span class="bundle-builder-line-item__quantity"></span>
                <button
                  type="button"
                  class="bundle-builder-line-item__control"
                  data-box-increment
                >
                  +
                </button>
              </div>
            `;
          }

          const imageContainer = item.querySelector('.bundle-builder-line-item__image');
          const titleNode = item.querySelector('.bundle-builder-line-item__title');
          const categoryNode = item.querySelector('.bundle-builder-line-item__category');
          const controlsNode = item.querySelector('.bundle-builder-line-item__controls');
          const decrementButton = item.querySelector('[data-box-decrement]');
          const incrementButton = item.querySelector('[data-box-increment]');
          const quantityNode = item.querySelector('.bundle-builder-line-item__quantity');

          if (imageContainer) {
            if (safeImage) {
              let imageNode = imageContainer.querySelector('img');
              if (! imageNode) {
                imageContainer.innerHTML = '';
                imageNode = document.createElement('img');
                imageContainer.appendChild(imageNode);
              }
              imageNode.src = safeImage;
              imageNode.alt = safeTitle;
            } else {
              imageContainer.innerHTML = '<span class="bundle-builder-line-item__image-label" aria-hidden="true">img</span>';
            }
          }

          if (titleNode) 
            titleNode.textContent = details.title || '';
          

          if (categoryNode) 
            categoryNode.textContent = details.menuTitle || '';
          

          if (controlsNode) 
            controlsNode.setAttribute('aria-label', `Quantity controls for ${
              details.title || 'product'
            }`);
          

          if (decrementButton) {
            decrementButton.dataset.productId = productId;
            decrementButton.setAttribute('aria-label', `Decrease quantity for ${
              details.title || 'product'
            }`);
            decrementButton.disabled = quantity <= 0;
          }
          if (incrementButton) {
            incrementButton.dataset.productId = productId;
            incrementButton.setAttribute('aria-label', `Increase quantity for ${
              details.title || 'product'
            }`);
            incrementButton.disabled = isPackFull;
          }
          if (quantityNode) 
            quantityNode.textContent = String(quantity);
          


          boxItems.appendChild(item);
          existingItems.delete(productId);
        });

        existingItems.forEach((item) => {
          item.remove();
        });
      };

      if (boxItems && ! boxItems.dataset.bound) {
        boxItems.addEventListener('click', (event) => {
          const decrementButton = event.target.closest('[data-box-decrement]');
          const incrementButton = event.target.closest('[data-box-increment]');

          if (decrementButton) {
            const productId = decrementButton.dataset.productId;
            decrementProduct(productId);
          }

          if (incrementButton) {
            const productId = incrementButton.dataset.productId;
            incrementProduct(productId);
          }
        });

        boxItems.dataset.bound = 'true';
      }

      if (moreInfoControlRegion && ! moreInfoControlRegion.dataset.bound) {
        moreInfoControlRegion.addEventListener('click', (event) => {
          if (! activeMoreInfoProductId) return;
          


          if (event.target.closest('[data-more-info-add]')) {
            incrementProduct(activeMoreInfoProductId);
          }

          if (event.target.closest('[data-more-info-decrement]')) {
            decrementProduct(activeMoreInfoProductId);
          }

          if (event.target.closest('[data-more-info-increment]')) {
            incrementProduct(activeMoreInfoProductId);
          }
        });

        moreInfoControlRegion.dataset.bound = 'true';
      }

      const syncCardControls = () => {
        const selectedCount = getSelectedCount();

        productCards.forEach((card) => {
          const productId = card.dataset.productId;
          const quantity = quantities.get(productId) || 0;
          const addButton = card.querySelector('[data-add-to-pack]');
          const quantityControl = card.querySelector('[data-quantity-control]');
          const decrementButton = card.querySelector('[data-quantity-decrement]');
          const incrementButton = card.querySelector('[data-quantity-increment]');
          const quantityValue = card.querySelector('[data-quantity-value]');
          const isPackFull = selectedCount >= maximumBundleSize;
          const isSoldOut = productData.get(productId) ?. isSoldOut === true;

          if (quantityValue) 
            quantityValue.textContent = String(quantity);
          

          if (addButton) {
            addButton.hidden = quantity > 0;
            addButton.disabled = isSoldOut || (isPackFull && quantity === 0);
          }

          if (quantityControl) 
            quantityControl.hidden = quantity === 0;
          

          if (decrementButton) 
            decrementButton.disabled = quantity <= 0;
          

          if (incrementButton) 
            incrementButton.disabled = isSoldOut || isPackFull;
          

        });
      };

      const updateBundleState = () => {
        const selectedCountBeforeTrim = getSelectedCount();

        if (selectedCountBeforeTrim > maximumBundleSize) {
          removeLatestSelections(selectedCountBeforeTrim - maximumBundleSize);
          announceStatus(`Your box was adjusted to fit the ${maximumBundleSize} meal maximum.`);
        }

        const selectedCount = getSelectedCount();
        const progressState = getProgressState(selectedCount);
        const currentPriceState = getCurrentPriceState(selectedCount);
        const remainingCount = progressState.remainingCount;
        const progressPercent = progressState.progressPercent;
        const progressMessage = progressState.progressMessage;

        selectedCountNodes.forEach((node) => {
          node.textContent = String(selectedCount);
        });

        minimumCountNodes.forEach((node) => {
          node.textContent = String(minimumBundleSize);
        });

        maximumCountNodes.forEach((node) => {
          node.textContent = String(maximumBundleSize);
        });

        remainingCountNodes.forEach((node) => {
          node.textContent = String(remainingCount);
        });

        progressBars.forEach((bar) => {
          bar.style.width = `${progressPercent}%`;
        });

        progressMessageNodes.forEach((node) => {
          node.textContent = progressMessage;
        });

        const nextReward = footer?.querySelector('[data-next-reward]');
        if (nextReward) {
          nextReward.hidden = selectedCount < minimumBundleSize || selectedCount >= bundleSize2Threshold;
          nextReward.textContent = priceMessages.nextSavings.replace(/\[\s*remaining\s*\]/gi, String(Math.max(bundleSize3Threshold - selectedCount, 0)));
        }

        currentTotalNodes.forEach((node) => {
          node.textContent = currentPriceState.total;
          node.hidden = ! currentPriceState.showPrice;
        });

        currentTotalCompareNodes.forEach((node) => {
          node.textContent = currentPriceState.compareAt;
          node.hidden = ! currentPriceState.compareAt;
        });

        currentTotalDiscountNodes.forEach((node) => {
          node.textContent = currentPriceState.discountLabel;
          node.hidden = ! currentPriceState.discountLabel;
        });

        currentTotalNoteNodes.forEach((node) => {
          node.textContent = currentPriceState.note;
          node.hidden = ! currentPriceState.note;
          node.classList.toggle('is-highlighted', currentPriceState.noteHighlighted);
        });


        progressMarkers.forEach((marker) => {
          const threshold = Number.parseInt(marker.dataset.progressThreshold || '0', 10) || 0;
          marker.classList.toggle('is-complete', selectedCount >= threshold);
        });

        bundleCtas.forEach((button) => {
          button.disabled = isSubmittingBundle || !progressState.canCheckout || !currentPriceState.valid;
        });

        submitBundleButtons.forEach((button) => {
          const labelNode = button.querySelector('[data-cta-label]');
          if (! labelNode) return;
          


          if (isSubmittingBundle) {
            labelNode.textContent = priceMessages.addingToCart;
          } else if (remainingCount === 0) {
            labelNode.textContent = button.dataset.completeLabel;
          } else {
            const prefix = button.dataset.ctaPrefix || '';
            const suffix = button.dataset.ctaSuffix || '';
            labelNode.innerHTML = `${
              escapeHtml(prefix)
            } <span data-remaining-count>${remainingCount}</span> ${
              escapeHtml(suffix)
            }`;
          }
        });

        if (boxEmptyState) 
          boxEmptyState.hidden = selectedCount > 0;
        

        if (boxItems) 
          boxItems.hidden = selectedCount === 0;
        


        syncCardControls();
        renderBoxItems();
        renderMoreInfoControl();
      };

      frequencySelect?.addEventListener('change', () => {
        requiresFrequencySelection = !frequencySelect.value;
        updateBundleState();
      });

      productCards.forEach((card) => {
        const productId = card.dataset.productId;
        const addButton = card.querySelector('[data-add-to-pack]');
        const decrementButton = card.querySelector('[data-quantity-decrement]');
        const incrementButton = card.querySelector('[data-quantity-increment]');

        if (productId) {
          quantities.set(productId, 0);
        }

        if (addButton) {
          addButton.addEventListener('click', () => {
            incrementProduct(productId);
          });
        }

        if (decrementButton) {
          decrementButton.addEventListener('click', () => {
            decrementProduct(productId);
          });
        }

        if (incrementButton) {
          incrementButton.addEventListener('click', () => {
            incrementProduct(productId);
          });
        }
      });

      updateBundleState();
      hydrateBundleFromCart();

      const showMoreInfoState = ({
        loading = false,
        error = false,
        html = ''
      } = {}) => {
        if (moreInfoLoading) 
          moreInfoLoading.hidden = !loading;
        

        if (moreInfoError) 
          moreInfoError.hidden = !error;
        

        if (moreInfoBody) 
          moreInfoBody.innerHTML = html;
        

      };

      const fetchMoreInfoContent = async (handle) => {
        if (moreInfoCache.has(handle)) {
          return moreInfoCache.get(handle);
        }

        const response = await fetch(`/products/${handle}?view=bundle-more-info`, {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (! response.ok) {
          throw new Error(`Failed to load meal details for ${handle}`);
        }

        const html = await response.text();
        moreInfoCache.set(handle, html);
        return html;
      };

      const openMoreInfo = async (productId, triggerButton) => {
        const details = productData.get(productId);
        if (! details ?. handle || ! moreInfoPanel) return;
        


        activeMoreInfoProductId = productId;
        activeMoreInfoRequestId += 1;
        const requestId = activeMoreInfoRequestId;

        renderMoreInfoControl();
        showMoreInfoState({loading: true, error: false, html: ''});
        openMoreInfoPanel(triggerButton);

        try {
          const html = await fetchMoreInfoContent(details.handle);
          if (requestId !== activeMoreInfoRequestId || activeMoreInfoProductId !== productId) return;
          


          showMoreInfoState({loading: false, error: false, html});

          if (moreInfoPanelContent) 
            moreInfoPanelContent.scrollTop = 0;
          

          if (moreInfoPanel) 
            moreInfoPanel.scrollTop = 0;
          


          initMoreInfoGallery(moreInfoBody);
          initMoreInfoReviews(moreInfoBody);
          renderMoreInfoControl();
        } catch (error) {
          if (requestId !== activeMoreInfoRequestId || activeMoreInfoProductId !== productId) return;
          

          showMoreInfoState({loading: false, error: true, html: ''});
        }
      };

      moreInfoButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const card = button.closest('[data-product-card]');
          const productId = card ?. dataset.productId;
          if (! productId) return;
          

          openMoreInfo(productId, button);
        });
      });

      const handleDelegatedDrawerClick = (event) => {
        const boxCloseTrigger = event.target.closest('[data-box-close]');
        const moreInfoCloseTrigger = event.target.closest('[data-more-info-close]');
        const overlayTrigger = event.target.closest('[data-box-overlay]');

        if (boxCloseTrigger && panel ?. contains(boxCloseTrigger) && openSection === section && openPanelType === 'box') {
          event.preventDefault();
          event.stopPropagation();
          closeBoxPanel();
          return;
        }

        if (moreInfoCloseTrigger && moreInfoPanel ?. contains(moreInfoCloseTrigger) && openSection === section && openPanelType === 'info') {
          event.preventDefault();
          event.stopPropagation();
          closeMoreInfoPanel();
          return;
        }

        if (overlayTrigger && overlay === overlayTrigger && openSection === section) {
          event.preventDefault();
          if (openPanelType === 'box') 
            closeBoxPanel();
          

          if (openPanelType === 'info') 
            closeMoreInfoPanel();
          

        }
      };

      document.addEventListener('click', handleDelegatedDrawerClick);

      submitBundleButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;

          submitBundle();
        });
      });

      toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          if (openSection === section && openPanelType === 'box') {
            closeBoxPanel();
          } else {
            openBoxPanel(toggle);
          }
        });
      });

      const handlePanelKeydown = (event) => {
        if (event.key === 'Escape' && openSection === section && openPanelType) {
          event.preventDefault();
          if (openPanelType === 'box') 
            closeBoxPanel();
          

          if (openPanelType === 'info') 
            closeMoreInfoPanel();
          

          return;
        }

        if (event.key !== 'Tab') return;
        


        const activePanel = openPanelType
          ? getPanelByType(openPanelType)
          : null;
        if (! activePanel) return;
        


        const focusableElements = [... activePanel.querySelectorAll(focusableSelector)];
        if (focusableElements.length === 0) return;
        


        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      };

      if (panel) 
        panel.addEventListener('keydown', handlePanelKeydown);
      

      if (moreInfoPanel) 
        moreInfoPanel.addEventListener('keydown', handlePanelKeydown);
      

    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-new-template-packs"]) return;
  try {
    
$(document).ready(function ($) {
    const thumbnailsSlider = $('[data-product-thumbnails]');
    const mainSlider = $('[data-product-single-media-group]');
    thumbnailsSlider.slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        vertical: false,
        asNavFor: mainSlider,
        focusOnSelect: true
    });
    mainSlider.slick({
        infinite: false,
        slidesToScroll: 1,
        asNavFor: thumbnailsSlider,
        arrows: false
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-new-template"]) return;
  try {
    
$(document).ready(function($) {
  const thumbnailsSlider = $('[data-product-thumbnails]');
  const mainSlider = $('[data-product-single-media-group]');
  thumbnailsSlider.slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    vertical: false,
    asNavFor: mainSlider,
    focusOnSelect: true
  });
  mainSlider.slick({infinite: false, slidesToScroll: 1, asNavFor: thumbnailsSlider, arrows: false});
});
  } catch(e) { console.error(e); }
})();
})();
